// DS: CMPST38
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { Url } from '@wix/da-url';
import { ListItemLink } from '@wix/da-ds/pkg/List/ListItem';
import DSModal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import StreamedList from '../StreamedList';
import UserAvatar from '../User/Avatar';
import UserLink from '../User/Link';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import AuthorWatchButton from '../Button/AuthorWatchButton';
import s from './FavouritedByModal.scss';
export const FavouritedByModal = ({ streamId, isInitialized, isLoading, users, currentUser, initializeStream, requestClose })=>{
    const { t } = useTranslation();
    useEffect(()=>{
        if (!isInitialized) {
            initializeStream();
        }
    }, [
        isInitialized,
        initializeStream
    ]);
    return /*#__PURE__*/ React.createElement(DSModal, {
        isOpen: true,
        heading: t('favouritedByModal.dialogTitle'),
        className: s['root'],
        onRequestClose: requestClose,
        withScrollableContentWrapper: false
    }, /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            sectionname: 'fave_pop_up'
        }
    }, /*#__PURE__*/ React.createElement(StreamedList, {
        streamId: streamId,
        className: s['list']
    }, users.map((user, index)=>{
        var _user_profile;
        const isNotCurrentUser = user.userId !== (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId);
        return /*#__PURE__*/ React.createElement(ListItemLink, {
            key: `${index}-${user.userId}`,
            prefix: /*#__PURE__*/ React.createElement(UserAvatar, {
                withTooltip: false,
                user: user,
                size: 40
            }),
            label: /*#__PURE__*/ React.createElement(UserLink, {
                user: user,
                withTooltip: false,
                className: s['userlink']
            }),
            subLabel: (_user_profile = user.profile) === null || _user_profile === void 0 ? void 0 : _user_profile.tagline,
            suffix: isNotCurrentUser && /*#__PURE__*/ React.createElement(AuthorWatchButton, {
                author: user
            }),
            href: Url.userLink(user.username)
        });
    }))), (!isInitialized || isLoading) && /*#__PURE__*/ React.createElement(LoadingIndicator, null));
};
FavouritedByModal.displayName = 'FavouritedByModal';
export default FavouritedByModal;

//# sourceMappingURL=FavouritedByModal.js.map